import { connect } from 'react-redux';
import { useCallback } from 'react';

import { Modal } from 'UIPackage/ModalModule/components/Modal';
import { ModalHeader } from 'UIPackage/ModalModule/components/ModalHeader';
import { ModalBody } from 'UIPackage/ModalModule/components/ModalBody';
import { ModalActions } from 'UIPackage/ModalModule/components/ModalActions';
import { Button } from 'UIPackage/MainModule/components/Button';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getKnmFormRef, getKnmOnSaveButtonClick } from 'KnmPackage/MainModule/selectors/knmSelectors';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { Hint } from 'CorePackage/MainModule/components/Hint';

import styles from './ErknmFinishRoPassportModal.module.scss';

interface IErknmFinishRoPassportModalProps {
  visible: boolean;
  onClose: () => void;
}

interface IErknmFinishRoPassportModalStoreProps {
  formRef: IKnmFormRef | undefined;
  onSaveButtonClick: (() => void) | undefined;
}

const ErknmFinishRoPassportModalWithoutStore = ({
  visible,
  onClose,
  formRef,
  onSaveButtonClick,
}: IErknmFinishRoPassportModalProps & IErknmFinishRoPassportModalStoreProps) => {
  const handleFinish = useCallback(async () => {
    formRef?.current?.change('completedRO', true);
    onSaveButtonClick && onSaveButtonClick();
    onClose();
  }, [onSaveButtonClick, formRef]);

  return (
    <>
      <Modal visible={visible} onClose={onClose}>
        <ModalHeader title="Завершение мероприятия" />
        <ModalBody size="content">
          <span className={styles.HelpText}>
            <Hint
              text="По нажатию на кнопку «Завершить мероприятие» добавление новых актов будет заблокировано, мероприятие будет
            завершено."
            />
          </span>
        </ModalBody>
        <ModalActions>
          <Button text="Вернуться" size="medium" type="button" onClick={onClose} />
          <Button text="Завершить мероприятие" color="primary" size="medium" type="button" onClick={handleFinish} />
        </ModalActions>
      </Modal>
    </>
  );
};

const mapStateToProps = (state: IRootState): IErknmFinishRoPassportModalStoreProps => ({
  formRef: getKnmFormRef(state),
  onSaveButtonClick: getKnmOnSaveButtonClick(state),
});

export const ErknmFinishRoPassportModal = connect(mapStateToProps)(ErknmFinishRoPassportModalWithoutStore);
